import ScenarioPage from "../../scenario-management/components/scenario-page";
import useNotification from "../../../../components/notification/notification";
import ApiSurveyTaskManagement from "../../../../api/survey-task-management";
import ApiTaskManagement from "../../../../api/task-managements";
import ApiScenariosManagement from "../../../../api/scenarios-management";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { nodeItemsConfig } from "../../scenario-management/configs/default-task-items-config";

const VersionPage = ({ task, setShowVersionPage, handleDeselect }) => {
  const { openNotification } = useNotification();
  const [tasks, setTasks] = useState([]);
  const [changeLogs, setChangeLogs] = useState({});

  const pickScenarioVersion = (task) => {
    const versions = task?.DailyTaskVersions || [];
    if (!versions.length) return null;

    const priority = ['pending', 'activeCopy', 'active'];

    for (const st of priority) {
      const found = versions.find(v => v.status === st);
      if (found) return found;
    }

    return versions[0];
  };

  const normalizeScenario = (task) => {
    // const scenarioVersion = task.DailyTaskVersions ? task.DailyTaskVersions[0] : undefined
    const scenarioVersion = pickScenarioVersion(task);
    const scenarioStatus = scenarioVersion?.status
      ? (scenarioVersion.status === 'activeCopy'
          ? 'active'
          : scenarioVersion.status === 'pending'
            ? 'pending'
            : scenarioVersion.status)
      : undefined;

    return {
      ...task,
      name: task.title,
      ScenarioVersion: scenarioVersion,
      facts: {},
      status: scenarioStatus
    };
  };

  const [scenario, setScenario] = useState(normalizeScenario(task));

  useEffect(() => {
    let normalizedScenario = normalizeScenario(task)
    setScenario(normalizedScenario)
    setChangeLogs({ [normalizedScenario.id]: task?.changeLogs || [] });
  }, [task]);

  const closeScenarioEditor = async () => {
    if (handleDeselect) {
      handleDeselect();
    } else {
      setShowVersionPage(false);
    }
  };

  const getDailyTasks = async () => {
    return ApiScenariosManagement.getDailyTasks().then((r) => {
      setTasks(r.data.dailyTasks);
    });
  };

  useEffect(() => {
    getDailyTasks();
  }, []);

  const refreshScenario = async (deselect, query = "") => {
    const resp = await ApiTaskManagement.getTaskById(task.id);
    const freshTask = resp?.data?.task;
    const normalizedScenario = normalizeScenario(freshTask);

    setChangeLogs({ [normalizedScenario.id]: freshTask?.changeLogs || [] });
    setScenario(normalizedScenario);
  };

  if (!scenario || !scenario.id) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><Spin /></div>;
  }

  return (
    <ScenarioPage
      scenario={scenario}
      toList={closeScenarioEditor}
      refreshScenario={refreshScenario}
      openNotification={openNotification}
      api={ApiSurveyTaskManagement}
      isSurveyTask
      tasks={tasks}
      itemsConfigOverride={nodeItemsConfig}
      changeLogs={changeLogs}
    />
  )
};

export default VersionPage;
